<div class="geolocation-modal" *ngIf="isModalOpen">
  <div
    class="geolocation-modal__container"
    [id]="PROMPT_MODAL_ID"
    *ngIf="(geolocationState$ | async) !== permissionStates.denied"
  >
    <img
      class="geolocation-modal__icon"
      src="/images/icons/icons-outline-atm-icn-alert-info.svg"
      alt="Información"
    />
    <p class="geolocation-modal__description">
      Permite el acceso a tu ubicación para que puedas retirar, transferir,
      comprar y vender.
      <button
        class="geolocation-modal__text-button"
        type="button"
        (mouseenter)="showTooltip = true"
        (mouseleave)="showTooltip = false"
      >
        Conocer más
        <hb-tooltip-component
          *ngIf="showTooltip"
          [text]="GEOLOCATION_INFO"
          relativePosition="top"
          width="288"
          [isLarge]="true"
          (onClose)="showTooltip = false"
        >
        </hb-tooltip-component>
      </button>
      <br />
      <br />
      Da clic en "Permitir" sobre la notificación que aparece en la parte
      superior de tu explorador.
    </p>

    <button
      class="button button--small button--light clickable geolocation-modal__footer-button"
      type="button"
      (click)="closeModal()"
    >
      Entendido
    </button>
  </div>

  <div
    class="geolocation-modal__container geolocation-modal--filled"
    [id]="DENIED_MODAL_ID"
    *ngIf="(geolocationState$ | async) === permissionStates.denied"
  >
    <button
      class="geolocation-modal__close-button link clickable"
      type="button"
      (click)="closeModal()"
    >
      <img src="images/icons/atm-alert-icn-close.svg" />
    </button>
    <img src="images/icons/atm-icn-pointer.svg" />
    <p>
      <b>Habilita el permiso de ubicación</b> para poder retirar, transferir,
      comprar y vender
    </p>
    <ol class="geolocation-modal__step-list">
      <li>
        Da click en el icono
        <img src="images/icons/atm-padlock.svg" />
        de la barra de navegación y selecciona “Configuración de sitios”
      </li>
      <li>
        Se abrirá una pestaña nueva y en la opción “Ubicación” cambia la
        configuración a “Permitir”
      </li>
      <li>
        Regresa a la pestaña de GBM+ y da clic en el ícono
        <img src="images/icons/atm-refresh.svg" /> para actualizar la página
      </li>
    </ol>
    <div class="geolocation-modal__notice-container">
      <img
        src="images/icons/atm-icn-alert-info.svg"
        alt="Información"
        class="geolocation-modal__notice-icon"
      />
      <div class="geolocation-modal__notice-text">
        Si ya habilitaste los permisos, revisa la
        <b> Configuración de Privacidad </b>
        de tu dispositivo
      </div>
    </div>
  </div>
</div>
